import {OfferListSearchData} from "../types/OfferListSearchData";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";
import {searchHitAlgolytics} from "./search_algolytics";

export const forInvestmentOfferListSearchHit = (
    category: string | null,
    subcategory: string | null,
    offersData: {offer_id: number[]; offer_name: string[]; vendor_id: number[]; vendor_name: string[]},
    searchData: OfferListSearchData
) => {
    const payload = {
        view_type: "for_investment_offer_list",
        category,
        subcategory,
        ...offersData,
        ...getTrackedSiteData(),
        ...searchData
    };
    searchHitAlgolytics(payload);
};
import {OfferListSearchData} from "../types/OfferListSearchData";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";
import {searchHitAlgolytics} from "./search_algolytics";

export const forInvestmentOfferListSearchHit = (
    category: string | null,
    subcategory: string | null,
    offersData: {offer_id: number[]; offer_name: string[]; vendor_id: number[]; vendor_name: string[]},
    searchData: OfferListSearchData
) => {
    const payload = {
        view_type: "for_investment_offer_list",
        category,
        subcategory,
        ...offersData,
        ...getTrackedSiteData(),
        ...searchData
    };
    searchHitAlgolytics(payload);
};
